module.exports = __webpack_public_path__ + "img/00031.d999ba84.webp";